/**
 * Labstep
 */

import type { ValueGetterParams } from 'ag-grid-community';
import { UserPreview } from 'labstep-web/components/User/Preview';
import { ICONS } from 'labstep-web/constants/icons';
import type { CellRendererParams } from 'labstep-web/core/DataGrid/types';
import type { Entity } from 'labstep-web/models/entity.model';

export const colDefOrderRequestAuthor = {
  colId: `author`,
  headerName: 'Requested by',
  headerComponentParams: {
    icon: ICONS.user.primary,
  },
  editable: false,
  valueGetter: (params: ValueGetterParams) =>
    params.data.author?.idAttr || null,
  cellRenderer: (params: CellRendererParams<Entity>) => {
    if (!params.data) {
      return '';
    }
    const user = params.data.author;
    return user ? <UserPreview user={user} /> : null;
  },
};
